import React from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div
      className="min-h-[70vh] flex flex-col items-center justify-center px-6 text-center"
      data-testid="notfound-page"
    >
      <div className="text-[10px] tracking-[0.32em] uppercase text-[#C5A059]">
        Lost in the Margins
      </div>
      <h1 className="font-display text-5xl md:text-7xl text-[#EAE0D5] mt-4">
        404 — Page Unbound
      </h1>
      <p className="text-[#A39E99] mt-4 max-w-md">
        This page is not in the atlas. Perhaps it has not been written yet.
      </p>
      <Link
        to="/"
        data-testid="notfound-home-link"
        className="mt-8 bg-[#C5A059] text-black px-7 py-3 text-xs tracking-[0.22em] uppercase hover:bg-[#D4AF68]"
      >
        Return Home
      </Link>
    </div>
  );
}
